<template>
    <div class="center w-full pl-0 pr-0 xl:pl-4 xl:pr-4 lg:pl-3 lg:pr-3">
		<div class="flex w-full justify-content-center align-items-center pt-0 pb-0 xl:pt-4 xl:pb-8 lg:pt-3 lg:pb-5">
			<div class="flex flex-column w-full pt-4 pl-3 pr-3 pb-4 xl:p-6 lg:p-5 md:p-4 xl:border-round-xl lg:border-round-xl">
                <span class="flex text-900 font-medium mb-4 xl:mb-6 text-3xl xl:text-6xl lg:text-5xl md:text-4xl justify-content-center">
                    {{ content[lang].title }}
                </span>
                <div class="flex w-full flex-column justify-content-center align-items-center m-auto 
                    mb-6" style="max-width:640px;">
                    <span class="inline-block m-auto justify-content-center align-items-center text-600 text-lg mb-4 line-height-2">
                        {{ content[lang].text }}
                    </span>
                </div>
                <div class="flex w-full flex-column justify-content-center align-items-center m-auto 
                    mb-6" style="max-width:640px;">
                    <Button :label="content[lang].btn" @click="goCreate" class="p-button-lg w-full max-w-20rem border-round-xl bg-green-200 text-lg text-green-600 border-none"/>
                </div>
			</div>
		</div>
	</div>

</template>

<script>
export default {
    name: 'CashPage',
    data() {
        return {
            content: {
                ru: {
                    title: 'Как снять наличные в ATM',
                    text: 'Точно так же как при создании онлайн-перевода, вы можете выбрать Банк получателя – Выдача наличных в банкомате. Далее оплатить перевод и действовать по инструкции.',
                    btn: 'Снять наличные'
				},
				en: {
                    title: 'How to withdraw cash at ATM',
                    text: 'Just like when creating an online transfer, you can choose the Recipient Bank - Cash Withdrawal at the ATM. Then pay for the transfer and follow the instructions.',
                    btn: 'Withdraw cash'
				}
			},
        }
    },
    computed: {
        lang() {
            return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
        }
    },
    methods: {
        goCreate(){
            this.$router.push({
                path: '/personal/transfer/create/'
            })
        },
    },
    beforeCreate() {

    },
}
</script>